import { useMutation } from '@tanstack/react-query';

import { getTourCategoriesSuggestion } from '~/services/ToursService';

/** svc-tour suggests categories from the tour's content. */
export function useSuggestTourCategories(legacyTourId: string) {
  return useMutation({
    mutationFn: async (): Promise<Array<string>> => {
      const response = await getTourCategoriesSuggestion(`tour-${legacyTourId}`);
      return (response?.result?.suggestedCategories ?? []) as Array<string>;
    },
  });
}
